import { render, staticRenderFns } from "./recaudaciones.vue?vue&type=template&id=6528188d"
import script from "./recaudaciones.vue?vue&type=script&lang=js"
export * from "./recaudaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports